module.exports = __webpack_public_path__ + "static/media/tamires.0ada0cb6.bin";